export default __webpack_public_path__ + "1cdef49100a51e35264a88df8d01af77.ttf";